import React, { useState } from "react";
import ReactModal from "react-modal";

import ListingList from "../../../../components/listing/List";
import { Button, ButtonGroup, Icon, IconButton } from "../../../../components/ui";
import SelectableListingCard from "./SelectableListingCard";
import "./select-listing-modal.scss";

/**
 * The picker itself — header, listing grid, Cancel / confirm. The quote
 * workspace (new setup) renders it inline; SelectListingModal wraps it in a
 * modal for the DAO setup.
 */
export const SelectListingPanel = ({
  productId,
  currentListingId,
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  const [selected, setSelected] = useState(null);

  if (!productId) {
    return null;
  }

  return (
    <>
      <div className="select-listing-modal__header">
        <h3>{currentListingId ? "Change listing" : "Select listing"}</h3>
        <IconButton
          variant="ghost"
          size="sm"
          label="Close"
          onClick={onClose}
          disabled={isSubmitting}
          data-btn="listing-select-close"
        >
          <Icon name="X" size="sm" />
        </IconButton>
      </div>

      <div className="select-listing-modal__body">
        <ListingList
          list="uploaded"
          filters={{ product_id: productId }}
          itemComponent={SelectableListingCard}
          itemComponentProps={{
            selectedId: selected?.id,
            currentListingId,
            productId,
            onSelect: setSelected,
          }}
          limit={48}
        />
      </div>

      <ButtonGroup align="end" className="select-listing-modal__footer">
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={isSubmitting}
          data-btn="listing-select-cancel"
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={!selected}
          loading={isSubmitting}
          onClick={() => onConfirm(selected)}
          data-btn="listing-select-confirm"
        >
          {currentListingId ? "Change listing" : "Select listing"}
        </Button>
      </ButtonGroup>
    </>
  );
};

const SelectListingModal = (props) => {
  if (!props.productId) {
    return null;
  }

  return (
    <ReactModal
      isOpen
      onRequestClose={props.isSubmitting ? undefined : props.onClose}
      className="select-listing-modal"
      overlayClassName="select-listing-modal__overlay"
      ariaHideApp={false}
    >
      <SelectListingPanel {...props} />
    </ReactModal>
  );
};

export default SelectListingModal;
